import axios from "axios";

const REPORTS_API = "https://backend.reportingbot.in/api/ecg/vendor/reports/";

/**
 * Fetches the ECG vendor reports list.
 *
 *   getECGReports()                                   -> page 1, page_size 20, no filters
 *   getECGReports({ customer: 5 }, 2)                 -> page 2 filtered by customer id
 *   getECGReports({ search: "Rahul", customer: 5 }, 1) -> search + customer filter combined
 *
 * Only `search`, `customer`, `test_date`, and `report_date` are ever sent.
 * There is intentionally no `location` filter param — location is a
 * table-only value returned per report, not a filterable field.
 *
 * The backend determines the vendor from the authenticated session, so we
 * never send a vendor_id here. Auth is handled the same way as the rest of
 * the app: `withCredentials: true` on the shared axios instance/session
 * cookie. If the project already has an axios instance with an auth
 * interceptor, swap `axios` below for that instance instead of importing
 * axios directly.
 */
export const getECGReports = async (filters = {}, page = 1, pageSize = 20) => {
  const params = {};

  if (filters.search && filters.search.trim()) {
    params.search = filters.search.trim();
  }
  if (filters.customer) {
    params.customer = filters.customer;
  }
  if (filters.test_date) {
    params.test_date = filters.test_date;
  }
  if (filters.report_date) {
    params.report_date = filters.report_date;
  }

  params.page = page;
  params.page_size = pageSize;

  const response = await axios.get(REPORTS_API, {
    params,
    withCredentials: true,
  });

  return response.data;
};

export default { getECGReports };